import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, Platform } from '@ionic/angular';
import { advertisement, ServiceService } from '../service.service';

@Component({
  selector: 'app-bags-jobs',
  templateUrl: './bags-jobs.page.html',
  styleUrls: ['./bags-jobs.page.scss'],
})
export class BagsJobsPage implements OnInit {
  datos;
  arrayVistas:Array<any> = [
  {id: 1, imageUrl: 'assets/images/bagsjobs/1.png', link: '/bags-jobs/cv',descripcion:'Déjanos tu CV', title:'Profesionista'},
  {id: 2, imageUrl: 'assets/images/bagsjobs/2.png', link: '/bags-jobs/company', descripcion:'Publica una vacante',title: 'Empresa'},
  {id: 3, imageUrl: 'assets/images/bagsjobs/3.png', link: '/trabajo', descripcion: 'Ver vacantes', title: 'Profesionista / Practicante'}, 
  {id: 4, imageUrl: 'assets/images/bagsjobs/4.png', link: '',title: 'Universitario', descripcion: 'Déjanos tu CV'}];
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(private loadingController: LoadingController, public services:ServiceService, private platform: Platform,private router: Router) { }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    this.getWorkOfferMix();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(7);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async getWorkOfferMix(){
    const loading = await this.loadingController.create({message: 'Espere por favor ...'});
    await loading.present();
    (await this.services.getWorkOfferMix()).subscribe(
      (data:any)=>{
        if(data[0].workofferMix){
          localStorage.setItem("emailEmpresas",data[0].workofferMix);
        }
        if(data[1].workofferMix){
          localStorage.setItem("whatsappUniversidad",data[1].workofferMix);
        }
      },
      async (error)=>{ await loading.dismiss(); },
      async ()=>{ await loading.dismiss();this.bringWorkOffers(); }
    );
  }
  
  openWhatsapp(){
    let whatsapp:string = localStorage.getItem("whatsappUniversidad");
    if (this.platform.is('desktop')) {
      window.open(whatsapp, '_system', 'location=yes')
    } else {
      this.services.openFrame(`${whatsapp}`);
    }
    
  }

  async bringWorkOffers() {
    const loading = await this.loadingController.create({message: 'Espere por favor ...'});
    await loading.present();

    this.services.jobExchange().subscribe(data => {
      this.datos = data;
      
      if(this.datos.length > 4){
        //let elementosEliminados = this.datos.splice(1, 4);
        this.datos.length = 4;
      }
    },
      error => {
      },()=>{
        loading.dismiss();
      }
    );
  }

  sendJobId(id){
    this.router.navigate(['/detallesvacante', id]);
  }

  public gotoURL(route:string){
    this.router.navigate([route]);
  }

}
